import { Component, Input, OnInit } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { OfferWithImage } from '@/model/offer-with-image';

@Component({
  selector: 'app-offer-location-display',
  imports: [MatIconModule],
  templateUrl: './offer-location-display.component.html',
  styleUrls: ['./offer-location-display.component.scss'],
  standalone: true,
})
export class OfferLocationDisplayComponent implements OnInit {
  @Input() offer!: OfferWithImage;

  locationTitle = '';
  locationList: string[] = [];
  iconName = 'pin_drop';

  ngOnInit(): void {
    this.determineLocationInfo();
  }

  private determineLocationInfo(): void {
    if (!this.offer) return;

    if (this.offer.bundeslaender && this.offer.bundeslaender.length > 0) {
      this.locationTitle =
        this.offer.bundeslaender.length === 1
          ? 'Verfügbar im folgenden Bundesland'
          : 'Verfügbar in folgenden Bundesländern';
      this.locationList = this.offer.bundeslaender.map((state) => state.name);
      this.iconName = 'location_on';
      return;
    }

    if (this.offer.bezirke && this.offer.bezirke.length > 0) {
      this.locationTitle =
        this.offer.bezirke.length === 1
          ? 'Verfügbar im folgenden Bezirk'
          : 'Verfügbar in folgenden Bezirken';
      this.locationList = this.offer.bezirke.map((district) => district.name);
      this.iconName = 'location_on';
      return;
    }

    if (this.offer.orte && this.offer.orte.length > 0) {
      this.locationTitle =
        this.offer.orte.length === 1
          ? 'Verfügbar am folgenden Ort'
          : 'Verfügbar an folgenden Orten';
      this.locationList = this.offer.orte.map(
        (location) => `${location.plz}, ${location.name}`,
      );
      this.iconName = 'location_on';
      return;
    }

    // Default fallback if no location info is available
    this.locationTitle = 'Verfügbar in ganz Österreich';
    this.locationList = [];
    this.iconName = 'location_on';
  }
}
